import { Store } from "pullstate";

export type FormStateProps = {
  cpf: string;
  email: string;
};

export const FormState = new Store({} as FormStateProps);
